// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2g_-R","notes":"Notes_notes__1XWL8"};